export default {
  common: {
    yes: 'Sí',
    no: 'No',
    currency: { php: 'PHP', vnd: 'VND', cny: 'CNY', all: 'Todas las Monedas' },
    status: {
      sufficient: 'Suficiente {pct}%',
      warning: 'Advertencia {pct}%',
      exhausted: 'Agotado',
      unallocated: 'Sin Asignar',
    },
    change: { add: '+ Añadir', sub: '- Reducir', consume: 'Ajuste Consumido' },
    remaining: 'Restante',
    totalAmount: 'Cuota Total',
    usedAmount: 'Usado',
    noPermission: '- Sin Permiso -',
    self: '(Propio)',
    exportExcel: 'Exportar Excel',
  },
  sys: {
    column: {
      title: 'Cuota Adj. de Usuario',
      subtitle: 'Disponible / Total',
      subtitleNew: 'Admin de plataforma · Ajuste de miembro',
      tagRefactor: 'RENOVADO',
    },
    btn: { manage: 'Gestionar Cuota', manageNew: 'Nuevo' },
    section: {
      userTitle: 'Cuota de Ajuste de Usuario',
      userSubtitle: 'Admin de plataforma · Ajuste de saldo de miembro',
      agentTitle: 'Cuota de Asignación de Agente',
      agentSubtitle: 'Marketing · Asignar a agentes',
    },
    manage: {
      title: 'Gestión de Cuota de Cuenta',
      totalUsed: 'Total Usado: ',
      remainingLabel: 'Restante',
      monthlyConsumed: 'Este Mes',
      monthlyUser: 'Usuario',
      monthlyAgent: 'Agente',
      viewAllPrefix: 'Ver todos los registros de cambio de cuota',
      viewAllLink: 'Registro de Cambio de Cuota',
      recentChanges: 'Cambios Recientes',
      recentChangesSub: 'Últimos 5',
      viewAll: 'Ver Detalle Completo →',
      memberLabel: 'Miembro',
      typeAdd: '+ Añadir',
      typeSub: '- Reducir',
      typeConsume: 'Ajuste Consumido',
      col: {
        time: 'Hora',
        type: 'Tipo',
        currency: 'Moneda',
        change: 'Cambio',
        afterRemain: 'Después',
        operatorRemark: 'Operador / Observación',
      },
    },
    adjust: {
      title: 'Ajustar Cuota',
      opType: 'Tipo de Operación',
      add: '+ Añadir',
      sub: '- Reducir',
      amount: 'Monto ({currency})',
      reason: 'Motivo',
      reasonPlaceholder: 'Por favor ingrese el motivo para este cambio de cuota (para auditoría)',
      reasonMaxLen: 'Máximo 100 caracteres',
      amountRequired: 'Por favor ingrese monto',
      amountMin: 'El monto debe ser mayor que 0',
      reasonRequired: 'Por favor ingrese motivo',
      preview: {
        after: '→ Después: Restante {remain} / Total {total}',
        error: '⚠ No se puede reducir esta cantidad; excede la cuota disponible restante ({remain})',
      },
      myAvailable: 'Mi disponible ({currency})',
      myQuotaEmpty: '⚠ No tiene cuota de asignación de agente restante. Por favor pida a un superadministrador que agregue antes de añadir.',
      exceedMyQuota: '⚠ Excede su cuota disponible ({myAvailable}); no puede añadir tanto.',
      singleLimit: {
        exceeded: 'El límite único de {dir} es {cur} {max}; esta transacción {cur} {amount} lo excede',
        add: 'aumento',
        reduce: 'disminución',
      },
      success: 'Éxito',
      fail: 'Falló',
    },
  },
  financial: {
    title: 'Registro de Cambio de Cuota',
    desc: 'Registra todos los cambios de cuota para cuentas backend: ① Ajuste de Cuota (admin ajusta manualmente la cuota de cuenta); ② Ajuste de Miembro (consumido cuando el operador realiza ajuste manual de saldo de miembro). Antes/después muestra (Disponible / Total).',
    tab: {
      opUser: 'Cuota de Cuenta Backend',
      agentAlloc: 'Asignación de Agente',
      agentBetween: 'Asignación Entre Agentes',
      memberAlloc: 'Asignación de Jugador',
      opUserGrant: 'Registros de Cuota de Agente Otorgada',
    },
    usage: {
      allocate: 'Asignar',
      recycle: 'Reciclar',
    },
    targetTag: {
      opUser: 'Cuenta Backend',
      agent: 'Agente',
      member: 'Jugador',
    },
    level: {
      platform: 'Plataforma',
      l1: 'Agente L1',
      l2: 'Agente L2',
      agent: 'Agente',
      superAdmin: 'Superadministrador',
    },
    filter: {
      timeRange: 'Hora de Cambio',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      operator: 'Operador',
      operatorPlaceholder: 'Cuenta de operador',
      targetAccount: 'Cuenta de Destino',
      targetPlaceholder: 'Cuenta backend de destino',
      agentAccount: 'Agente de Destino',
      agentPlaceholder: 'Buscar cuenta de agente',
      memberAccount: 'Jugador de Destino',
      memberPlaceholder: 'Buscar cuenta de jugador',
      bizType: 'Tipo de Cambio',
      bizTypeAll: 'Todos los Tipos',
      currency: 'Moneda',
      currencyAll: 'Todas las Monedas',
    },
    bizType: {
      adjustConsume: 'Ajuste de Miembro',
      quotaAdjust: 'Ajuste de Cuota',
      opUserRefundFromMember: 'Reembolso de Deducción de Miembro',
    },
    col: {
      id: 'ID',
      time: 'Hora de Cambio',
      usage: 'Uso',
      operator: 'Operador',
      operatorLevel: 'Nivel de Operador',
      adjustReason: 'Motivo del Ajuste',
      refundFlag: 'Cuota Reciclada',
      countPayDeposit: 'Contado en Depósito/Retiro',
      targetAccount: 'Cuenta de Destino',
      targetMember: 'Miembro de Destino',
      currency: 'Moneda',
      bizType: 'Tipo de Cambio',
      changeAvailable: 'Cambio Disponible',
      changeTotal: 'Cambio Total',
      beforeAfterAvailable: 'Antes → Después (Disponible)',
      beforeAfterTotal: 'Antes → Después (Total)',
      grantAmount: 'Monto Otorgado',
      grantAmountSub: 'Disponible y total aumentan juntos',
      afterQuota: 'Después del Cambio',
      afterQuotaSub: 'Disponible / Total',
      bizNo: 'No. de Negocio',
      remark: 'Observación',
    },
  },
  my: {
    menuItem: 'Mi Cuota de Ajuste',
    modal: { title: 'Mi Cuota de Ajuste' },
    desc: 'Vea su cuota de ajuste actual e historial de cambios. Póngase en contacto con un administrador con permiso de "Gestión de Cuota de Cuenta" para añadir cuota.',
    hero: { onlySelf: 'Cuenta de inicio de sesión actual · Visible solo para usted', monthConsumed: 'Consumido Este Mes: ', account: 'Cuenta', role: 'Rol' },
    currentQuota: { title: 'Cuota Disponible Actual', subtitle: 'Tiempo real · Se actualiza automáticamente después de cada ajuste' },
    agentAlloc: {
      title: 'Cuota de Asignación de Agente',
      subtitle: 'Asignar cuota a agentes (L1/L2) · Tiempo real · se actualiza automáticamente después de asignar/reciclar',
      monthUsed: 'Usado este mes',
    },
    card: { remainLabel: 'Cuota Restante', total: 'Total: {val}', monthUsed: 'Este Mes: {val}' },
    filter: {
      time7d: 'Últimos 7 Días', time30d: 'Últimos 30 Días',
      timeMonth: 'Este Mes', timeLastMonth: 'Mes Pasado',
      allCurrencies: 'Todas las Monedas', allTypes: 'Todos los Tipos',
      consumeType: 'Ajuste Consumido', addType: 'Añadido por Admin', subType: 'Reducido por Admin',
    },
    table: {
      time: 'Hora', type: 'Tipo', currency: 'Moneda',
      amount: 'Monto', afterRemain: 'Restante Después', detail: 'Miembro / Detalle',
    },
    total: '{count} registros en total',
  },
  chip: {
    label: 'Mi Cuota',
    unallocated: 'Sin Asignar',
    tooltip: 'Haga clic para ver mi cuota de ajuste',
  },
  opuser: {
    agent: {
      column: {
        title: 'Cuota Adj. de Agente',
        subtitle: 'Marketing · Asignar a agentes',
        tagNew: 'NUEVO',
      },
      btn: { manage: 'Cuota de Agente', manageNew: 'NUEVO' },
      manage: {
        title: 'Fondo de Asignación de Agente',
        banner: 'Este es el fondo del operador para asignar a agentes. Independiente de la cuota de ajuste de usuario a la izquierda.',
      },
      adjust: { title: 'Ajustar Fondo de Asignación de Agente', success: 'Éxito', fail: 'Falló' },
    },
  },
  agent: {
    btn: { manage: 'Cuota' },
    column: { title: 'Cuota Actual', subtitle: 'Usado / Disponible' },
    whitelist: {
      bannerTitle: 'Autorización de lista blanca: ',
      bannerDesc:
        'Este agente puede SOLO ajustar miembros en la lista blanca. Vacío predeterminado = el agente no puede ajustar ningún miembro. Los administradores de operaciones no se ven afectados.',
      addBtn: '+ Añadir Miembro',
      downloadTemplate: 'Plantilla',
      batchImportBtn: 'Importación Masiva',
      totalText: 'Total {count}',
      search: { placeholder: 'Buscar cuenta', btn: 'Buscar' },
      stats: {
        whitelistCount: 'En Lista Blanca:',
        directCount: 'Miembros Directos:',
        coverRate: 'Tasa de Cobertura:',
        unit: '',
        emptyHint: 'Vacío predeterminado: el agente no puede ajustar ningún miembro',
      },
      col: {
        account: 'Cuenta',
        vipLevel: 'VIP',
        addTime: 'Añadido el',
        addedBy: 'Por',
        action: 'Acción',
      },
      add: {
        accountLabel: 'Cuenta de Miembro',
        placeholder: 'Ingrese la cuenta de miembro completa',
        accountRequired: 'Se requiere cuenta',
        helpText: 'El miembro debe existir y pertenecer a este agente',
        success: 'Añadido',
        alreadyExists: 'El miembro ya está en la lista blanca',
      },
      failReason: {
        MEMBER_NOT_FOUND: 'Miembro no encontrado',
        NOT_DIRECT_MEMBER: 'El miembro no pertenece a este agente',
        QUERY_ERROR: 'Consulta fallida',
      },
      remove: {
        btn: 'Eliminar',
        confirmTitle: 'Confirmar eliminación',
        confirmContent: 'Eliminar {account} de la lista blanca. El agente ya no podrá ajustar a este miembro.',
        success: 'Eliminado',
      },
      batchImport: {
        title: 'Importar Miembros Masivamente',
        helpText: 'Cargue un archivo CSV / TXT, o pegue cuentas (una por línea, # = comentario).',
        uploadBtn: 'Cargar CSV / TXT',
        placeholder: 'Pegue cuentas aquí, una por línea',
        submit: 'Importar',
        empty: 'Por favor proporcione al menos una cuenta',
        done: 'Hecho — añadido {added}, omitido {skipped}, falló {failed}',
        added: '✓ Añadido',
        skipped: '⚠ Omitido (ya existe)',
        failed: '✗ Falló',
      },
    },
    manage: {
      title: 'Cuota de Ajuste de Agente',
      accountLabel: 'Cuenta',
      monthlyConsumedLabel: 'Este Mes',
      monthConsumed: 'Este Mes',
      poolTitle: 'Cuota de Ajuste (Fondo Único)',
      poolHint:
        'Notas: Fondo único L1 — la cuota de ajuste cubre AMBOS ajustes manuales de miembro Y asignaciones a subagentes L2. El fondo se comparte; no se separan.',
      typeAllocateIn: '↓ Asignado Dentro',
      typeAllocateOut: '↑ Asignado Fuera',
      tab: {
        quota: 'Cuota',
        memberConfig: 'Configuración de Miembro',
      },
      memberConfigComingSoon:
        'Esta pestaña es un marcador de posición. Está desacoplada de cuota y será conectada a su propia API más tarde.',
    },
  },
  wallet: {
    operatorRow: {
      operator: 'Operador: ',
      willDeduct: 'Este ajuste deducirá su cuota "{currency}"',
      viewDetail: 'Ver Detalle Completo →',
    },
    preview: {
      after: '→ Restante después: {remain} {currency}',
      insufficient: '→ Insuficiente por {amount} {currency}',
      viewDetail: 'Ver Detalle →',
    },
    banner: {
      title: 'Este Ajuste Será Bloqueado',
      desc: 'No se puede enviar: el monto del ajuste ({amount}) excede su cuota restante ({remain} {currency}). Por favor póngase en contacto con un administrador con permiso de "Gestión de Cuota de Cuenta".',
    },
  },
};
